<script>
    import {
        Navbar,
        NavbarBrand,
        Nav,
        NavItem,
        NavLink
    } from 'sveltestrap'
    import { navigate } from 'svelte-routing'
    import Login from './Login.svelte'
    import { currentUser } from '../stores/current_user'
</script>

<Navbar color="primary" dark expand="md">
<NavbarBrand href="/">Feeder Admin</NavbarBrand>
    {#if $currentUser}
    <Nav class="mr-3" navbar>
        <NavItem>
            <NavLink on:click={() => navigate('/tasks')}>Tasks</NavLink>
        </NavItem>
    </Nav>
    <Nav class="mr-3" navbar>
        <NavItem>
            <NavLink on:click={() => navigate('/agents')}>Agents</NavLink>
        </NavItem>
    </Nav>
    <Nav class="mr-auto" navbar>
        <NavItem>
            <NavLink on:click={() => navigate('/projects')}>Projects</NavLink>
        </NavItem>
    </Nav>
    {/if}
    <Nav class="ml-auto" navbar>
        <NavItem>
            <Login/>
        </NavItem>
    </Nav>
</Navbar>
